export const parseAppointedMedications = (value) => {
  if (!value) {
    return { active: "", inactive: "" };
  }

  if (typeof value === "object") {
    return {
      active: value.active || "",
      inactive: value.inactive || "",
    };
  }

  try {
    const parsed = JSON.parse(value);

    if (parsed?.__appointedMedications) {
      return {
        active: parsed.__appointedMedications.active || "",
        inactive: parsed.__appointedMedications.inactive || "",
      };
    }
  } catch (error) {
    // Legacy plain-text values are shown on the All tab only.
  }

  return { active: "", inactive: "", legacy: value };
};

export const serializeAppointedMedications = ({ active, inactive, legacy }) => {
  if (legacy) {
    return legacy;
  }

  return JSON.stringify({
    __appointedMedications: {
      active: active || "",
      inactive: inactive || "",
    },
  });
};

export const formatAppointedMedicationsForDisplay = (value) =>
  getAppointedMedicationsForTab(parseAppointedMedications(value), "All");

export const getAppointedMedicationsForTab = (appointed, activeStatus) => {
  if (activeStatus === "Active") {
    return appointed.active || "";
  }

  if (activeStatus === "Inactive") {
    return appointed.inactive || "";
  }

  return [appointed.active, appointed.inactive, appointed.legacy]
    .filter(Boolean)
    .join("\n");
};

export const updateAppointedMedicationsForTab = (
  appointed,
  activeStatus,
  value,
) => {
  if (activeStatus === "Active") {
    return { ...appointed, active: value, legacy: "" };
  }

  if (activeStatus === "Inactive") {
    return { ...appointed, inactive: value, legacy: "" };
  }

  return appointed;
};
